import { Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { EMPTY_CELL_DISPLAY } from '../../models/sort-table/cell-classes';

export interface CopyToastConfig {
  message?: string;
  icon?: string;
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class CopyToastService {
  constructor(private clipboard: Clipboard) {}
  show: boolean = false;
  message: string = 'Copied to clipboard';
  icon: string = 'fa-check-circle';

  private hideTimeout: any;

  showToast(config: CopyToastConfig = {}): void {
    // Clear any existing timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    // Update configuration
    this.message = config.message || 'Copied to clipboard';
    this.icon = config.icon || 'fa-copy';
    const duration = config.duration || 2000;

    // Show the toast
    this.show = true;

    // Auto-hide after duration
    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, duration);
  }

  hide(): void {
    this.show = false;
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }

  showCopied(text?: string): void {
    const message = text
      ? `Copied "${text.length > 20 ? text.substring(0, 20) + '...' : text}"`
      : 'Copied to clipboard';

    this.showToast({
      message,
      icon: 'fa-copy',
      duration: 2000
    });
  }

  /**
   * Copies text to clipboard and shows a toast notification
   * @param value The text to copy
   * @returns true if successful
   */
  copyToClipboard(value: string): boolean {
    // Don't copy empty or placeholder values
    if (!value || value === EMPTY_CELL_DISPLAY) return false;

    const success = this.clipboard.copy(value);
    if (success) {
      this.showCopied(value);
    }
    return success;
  }
}
